import { useUserStore } from '@/stores'
import { createRouter, createWebHistory } from 'vue-router'
import MemberRoutes from './member.js'

const Layout = () => import(/* webpackChunkName: "layout" */ '@/pages/AppLayout')
const Home = () => import(/* webpackChunkName: "home" */ '@/pages/home') // 首页
const SearchList = () => import(/* webpackChunkName: "search-list" */ '@/pages/searchList') // 搜索列表页
const ShopDetail = () => import(/* webpackChunkName: "shop-detail" */ '@/pages/shopDetail') // 商铺详情
const Product = () => import(/* webpackChunkName: "product" */ '@/pages/product/index') // 商品详情

const Order = () => import(/* webpackChunkName: "order" */ '@/pages/order/index.vue') // 订单

const PayCenter = () => import(/* webpackChunkName: "pay-center" */ '@/pages/paycenter/index.vue') // 支付中心

const Estimation = () => import(/* webpackChunkName: "estimation" */ '@/pages/estimation/index.vue') // 运费估算
const Carrier = () => import(/* webpackChunkName: "carrier" */ '@/pages/estimation/Carrier.vue') // 承运商估算

const ActiveMail = () => import(/* webpackChunkName: "active-mail" */ '@/pages/activeMail') // 激活邮箱
const Forget = () => import(/* webpackChunkName: "forget" */ '@/pages/forget') // 重置密码
const SubmitPackage = () => import(/* webpackChunkName: "submit-package" */ '@/pages/submitPackage') // 提交包裹
const UniOrder = () => import(/* webpackChunkName: "uni-order" */ '@/pages/uniOrder') // 手动下单

const Login = () => import(/* webpackChunkName: "login" */ '@/pages/login/index')

const RegisterSuccess = () =>
  import(/* webpackChunkName: "registerSuccess" */ '@/pages/registerSuccess/index') // 注册成功

const Test = () => import('@/pages/test/index')
const Faq = () => import(/* webpackChunkName: "faq" */ '@/pages/Faq/index') // Faq
const PaymentSuccess = () =>
  import(/* webpackChunkName: "payment-success" */ '@/pages/member/cart/paymentSuccess') // 支付成功
const OnerwaySuccess = () =>
  import(/* webpackChunkName: "payment-success" */ '@/pages/member/cart/onerwaySuccess') // onerway支付成功
const UnlimitSuccess = () =>
  import(/* webpackChunkName: "unlimit-success" */ '@/pages/member/cart/unlimitSuccess') // unlimit 成功页
const DlocalSuccess = () =>
  import(/* webpackChunkName: "dlocal-success" */ '@/pages/member/cart/dlocalSuccess') // dlocal 成功页
const CoinpalSuccess = () =>
  import(/* webpackChunkName: "coinpal-success" */ '@/pages/member/cart/coinpalSuccess') // coinpal 成功页
const HelpCenter = () => import('@/pages/helpCenter/index') // 帮助中心
const Transport = () => import(/* webpackChunkName: "transport" */ '@/pages/transport/index') // 转运
const CustomizedLogistics = () =>
  import(/* webpackChunkName: "Customized-logistics" */ '@/pages/customizedLogistics/index') // 定制物流
const CustomizedSuccess = () =>
  import(/* webpackChunkName: "CustomizedSuccess" */ '@/pages/customizedSuccess/index') // 定制物流成功
const SharePackage = () =>
  import(/* webpackChunkName: "SharePackage" */ '@/pages/sharePackage/index') // 分享包裹
const ShareCoupon = () => import(/* webpackChunkName: "ShareCoupon" */ '@/pages/shareCoupon/index') // 分享优惠券
const Classifier = () => import(/* webpackChunkName: "Classifier" */ '@/pages/classifier/index') // 分类
const ShoppingGuide = () =>
  import(/* webpackChunkName: "ShoppingGuide" */ '@/pages/shopping-guide/index') // 购物指南
const CartEstimate = () =>
  import(/* webpackChunkName: "CartEstimate" */ '@/pages/cartEstimate/index') // 购物车运费估算
const ShareQcImage = () =>
  import(/* webpackChunkName: "ShareQcImage" */ '@/pages/shareQcImage/index') // 分享图片
const ActivityNotice = () =>
  import(/* webpackChunkName: "ActivityNotice" */ '@/pages/activityNotice/index') // 活动公告
const ActivityNoticeDetail = () =>
  import(/* webpackChunkName: "ActivityNoticeDetail" */ '@/pages/activityNotice/detail') // 活动公告详情
// 路由规则
const routes = [
  // 一级路由布局容器
  // ...DistributionRoutes,
  // ...DistributionNewRoutes,
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      ...MemberRoutes,
      {
        path: '/member/cart/paymentSuccess',
        name: 'payment-success',
        component: PaymentSuccess,
      },
      {
        path: '/shopping-guide',
        name: 'shopping-guide',
        component: ShoppingGuide,
      },
      { path: '/home', name: 'home', component: Home },
      {
        path: '/transport',
        name: 'transport',
        component: Transport,
      },
      {
        path: '/onerwaySuccess',
        name: 'onerway-success',
        component: OnerwaySuccess,
      },
      {
        path: '/member/cart/dlocalSuccess',
        name: 'dlocal-success',
        component: DlocalSuccess,
      },
      {
        path: '/member/cart/unlimitSuccess',
        name: 'unlimit-success',
        component: UnlimitSuccess,
      },
      {
        path: '/member/cart/coinpalSuccess',
        name: 'coinpal-success',
        component: CoinpalSuccess,
      },

      { path: '/sharePackage', name: 'share-package', component: SharePackage },
      { path: '/search-list', name: 'search-list', component: SearchList },
      { path: '/shop-detail', name: 'shop-detail', component: ShopDetail },
      {
        path: '/product',
        name: 'product',
        component: Product,
        meta: {
          keepAlive: true,
        },
      },
      { path: '/estimation', name: 'estimation', component: Estimation },
      { path: '/estimation/carrier', name: 'carrier', component: Carrier },

      { path: '/uni-order', name: 'uni-order', component: UniOrder },
      {
        path: '/customized-logistics',
        name: 'customized-logistics',
        component: CustomizedLogistics,
      },
      { path: '/test', name: 'test', component: Test },
      {
        path: '/paycenter',
        name: 'paycenter',
        component: PayCenter,
      },
      { path: '/order', name: 'order', component: Order },

      {
        path: '/submit-package',
        name: 'submit-package',
        component: SubmitPackage,
      },
      {
        path: '/doc',
        name: 'faq',
        component: Faq,
      },
      { path: '/help-center', name: 'helpCenter', component: HelpCenter },
      {
        path: '/classifier',
        name: 'classifier',
        component: Classifier,
      },
      {
        path: '/cartEstimate',
        name: 'cart-estimate',
        component: CartEstimate,
      },
      { path: '/activityNotice', name: 'activity-notice', component: ActivityNotice },
      {
        path: '/activityNoticeDetail',
        name: 'activity-notice-detail',
        component: ActivityNoticeDetail,
      },
    ],
  },

  { path: '/activeMail', name: 'active-mail', component: ActiveMail },
  { path: '/forget', name: 'forget', component: Forget },
  { path: '/login', name: 'login', component: Login },

  {
    path: '/registerSuccess',
    name: 'register-success',
    component: RegisterSuccess,
  },
  {
    path: '/customizedSuccess',
    name: 'customized-success',
    component: CustomizedSuccess,
  },

  {
    path: '/:pathMatch(.*)',
    redirect: '/home',
    meta: { hidden: true },
  },
  {
    path: '/shareCoupon',
    name: 'share-coupon',
    component: ShareCoupon,
  },
  {
    path: '/shareQcImage',
    name: 'share-qc-image',
    component: ShareQcImage,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
})

// 前置导航守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()

  const isLogin = userStore.isLogin
  if (isLogin) {
    if (to.path === '/login') {
      next('/')
      return
    }
  }
  if (to.path === '/home') {
    document.title = 'acbuy'
  } else {
    document.title = to.name || 'acbuy'
  }
  next()
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const cssPattern = /Loading CSS chunk (\d)+ failed/g
  const isCssChunkLoadFailed = error.message.match(cssPattern)
  if (isChunkLoadFailed || isCssChunkLoadFailed) {
    setTimeout(() => {
      window.location.reload()
    }, 3000)
    // router.replace(router.history.pending.fullPath);
  } else {
    console.log(error)
  }
})

export default router
